import { render, staticRenderFns } from "./DashboardRoutesList.vue?vue&type=template&id=50aea86c&scoped=true"
import script from "./DashboardRoutesList.vue?vue&type=script&lang=js"
export * from "./DashboardRoutesList.vue?vue&type=script&lang=js"
import style0 from "./DashboardRoutesList.vue?vue&type=style&index=0&id=50aea86c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aea86c",
  null
  
)

export default component.exports